"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.parse-int.js");

var _jssha = _interopRequireDefault(require("jssha"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ImageUrlSigner {
  constructor(salt, secret, proxyHost) {
    _defineProperty(this, "_urlSafeBase64", string => {
      /* NOTE: btoa cannot handle multibyte characters correctly,
         however we are optimistic here that we will not need that (we
         encode urls and url-paths only). Luckily btoa will throw an
         error when it encounters an unencodable char so we will know
         when we need this.
          See: https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
       */
      let b64str = btoa(string);
      return b64str.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    });

    _defineProperty(this, "_hexDecode", hex => {
      let string = ''; // Each character in the original string is made of two
      // hex values. So we iterate through pairs of chars here.

      for (let index = 0; index < hex.length; index += 2) {
        let hexPair = hex.slice(index, index + 2); // e.g. '0d' or 'de' or '42'
        // Obtain char code by interpreting the string as a hex number

        let charCode = parseInt(hexPair, 16); // Convert char code to string representation and append to output string

        string += String.fromCharCode(charCode);
      }

      return string;
    });

    _defineProperty(this, "_sign", target => {
      const shaObj = new _jssha.default('SHA-256', "TEXT", {
        hmacKey: {
          value: this.secret,
          format: "HEX"
        }
      });
      shaObj.update(this._hexDecode(this.salt));
      shaObj.update(target);
      return this._urlSafeBase64(shaObj.getHash('BYTES'));
    });

    _defineProperty(this, "create", (originalImageUrl, config) => {
      let encodedUrl = this._urlSafeBase64(originalImageUrl);

      let path = "/rs:".concat(config.resizingType, ":").concat(config.width, ":").concat(config.height, ":").concat(config.enlarge, "/g:").concat(config.gravity, "/").concat(encodedUrl, ".").concat(config.extension);

      let signature = this._sign(path);

      let result = "https://".concat(this.proxyHost, "/").concat(signature).concat(path);
      console.log("created url: ", result);
      return result;
    });

    this.salt = salt;
    this.secret = secret;
    this.proxyHost = proxyHost;
  }

}

var _default = ImageUrlSigner;
exports.default = _default;